import React from 'react';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import { bindActionCreators, Dispatch } from 'redux';
import { pick } from 'lodash';
import MatchText from './MatchText';
import { wrap } from '../../lib/wrappers';
import a from '../../redux/actions';
import {
  UpdateLocationSuggestions, UpdateLocationAutocompleteInput, OnLocationAutocompleteSelected
} from '../../redux/actions/locationAutocomplete';
import s from '../../redux/selectors';
import { GooglePlace } from '../../redux/types';

interface Props {
  // manual props
  identifier: string;
  locationAutocompleteLoading: boolean;
  onLocationSelected: (suggestion: GooglePlace) => void;
  placeholder: string;
  // connected props
  locationAutocompleteInputDisplay: string;
  locationAutocompleteSuggestions?: GooglePlace[];
  updateLocationSuggestions: UpdateLocationSuggestions;
  hideLocationSuggestions: () => void;
  updateLocationAutocompleteInput: UpdateLocationAutocompleteInput;
  onLocationAutocompleteSelected: OnLocationAutocompleteSelected;
}

const LocationAutocomplete = ({
  updateLocationSuggestions,
  hideLocationSuggestions,
  onLocationSelected,
  locationAutocompleteSuggestions,
  locationAutocompleteInputDisplay,
  updateLocationAutocompleteInput,
  onLocationAutocompleteSelected,
  identifier,
  locationAutocompleteLoading,
  placeholder
}: Props) => {
  const onChange = (e: React.FormEvent<HTMLInputElement>) => {
    const value = (e.target as HTMLInputElement).value;
    updateLocationAutocompleteInput(value, identifier);
    if (!value) {
      onLocationSelected(null);
    }
  };
  return (
    <form className="location_autocomplete_form">
      <input type="hidden" value="autofillisterrible" />
      <Autosuggest
        suggestions={locationAutocompleteSuggestions}
        inputProps={{
          id: `${identifier}__location_autocomplete`,
          value: locationAutocompleteInputDisplay,
          placeholder,
          ariaLabel: placeholder,
          className: 'form-control',
          onChange,
          autoComplete: 'off'
        }}
        onSuggestionsFetchRequested={(update) => updateLocationSuggestions(update, identifier)}
        onSuggestionsClearRequested={hideLocationSuggestions}
        getSuggestionValue={(suggestion: GooglePlace) => suggestion.description}
        renderSuggestion={(suggestion: GooglePlace) => (
          <MatchText
            text={suggestion.description}
            match={locationAutocompleteInputDisplay}
          />
        )}
        onSuggestionSelected={(
          _event: React.FormEvent<HTMLElement>,
          { suggestion }: { suggestion: GooglePlace }
        ) => {
          onLocationAutocompleteSelected(suggestion, identifier);
          onLocationSelected(suggestion);
        }}
      />
      {locationAutocompleteLoading ? <div id="location_autocomplete__spinner" /> : null}
    </form>
  );
};

const mapStateToProps = (state: { locationAutocompleteLoading: boolean }, ownProps: Props) => [
  'locationAutocompleteSuggestions',
  'locationAutocompleteInputDisplay'
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps)
}), { locationAutocompleteLoading: state.locationAutocompleteLoading });

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  pick(a, [
    'hideLocationSuggestions',
    'updateLocationSuggestions',
    'updateLocationAutocompleteInput',
    'onLocationAutocompleteSelected'
  ]),
  dispatch
);

export default wrap(
  connect(mapStateToProps, mapDispatchToProps),
  LocationAutocomplete
);
